import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

type ContractSlice = CommonTableState;

const initialState: ContractSlice = {
    tableState: {
        resetIndicator: 0,
        sorting: [{ id: "created", desc: true }],
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        columnOrder: [
            "code",
            "description",
            "useAsDefault",
            "valid",
            "clientId",
            "externalId",
            "note",
            "created",
            "creator",
            "modified",
            "modifier",
            "mrt-row-actions",
        ],
        density: "compact",
    },
};

export const contractSlice = createSlice({
    name: "contract",
    initialState: initialState,
    reducers: {
        updateContractTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

// Action creators are generated for each case reducer function
export const { updateContractTableState } = contractSlice.actions;

export default contractSlice.reducer;
